// Story 7.33 (ADO-2026): a shelf plan's image, linked from SL1.0's plan image host (never stored
// or proxied). A plan with no image (`missing_image`, no file name), or one whose file fails to
// load, shows the branded placeholder and stays usable: its products do not depend on it.
import { useState } from 'react';
import { ProductImagePlaceholder } from '../../assets/ProductImagePlaceholder';
import styles from './Planograms.module.css';

export interface PlanogramImageProps {
  readonly src: string | null;
  readonly alt: string;
  readonly className?: string | undefined;
}

export function PlanogramImage({ src, alt, className }: PlanogramImageProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const trimmed = src?.trim() ?? '';
  const showPlaceholder = trimmed === '' || trimmed === failedSrc;
  return (
    <div className={`${styles.planImage} ${className ?? ''}`}>
      {showPlaceholder ? (
        <ProductImagePlaceholder role="img" aria-label={alt} />
      ) : (
        <img src={trimmed} alt={alt} loading="lazy" onError={() => setFailedSrc(trimmed)} />
      )}
    </div>
  );
}
